<div class="create-oco-order dropdown-content-root">
	<div class="top">
		<h3 class="title">{{ 'slTp.title' | translate }}</h3>
		<tui-icon
			class="icon"
			icon="@tui.x"
			(click)="onCloseDropdown()"
		/>
	</div>

	<div class="oco-order">
		<div>
			<h6 class="oco-order-title">{{ 'slTp.positionSize' | translate }}</h6>
			<app-quantity-selector
				[position]="position()"
				[isLoadingOrders]="isLoadingOrders()"
				(changeQty)="onChangeQty($event)"
			/>
		</div>

		<app-sl-tp-controls
			[isEnableBounds]="false"
			[qty]="resQty()"
			[isActiveStopLoss]="isSlTpActive().stopLoss"
			[isActiveTakeProfit]="isSlTpActive().takeProfit"
			[targetPrice]="+(position()?.avg_entry_price ?? 0)"
			[isBuy]="position()?.side === positionSideEnum.LONG"
			[defaultPercentTakeProfit]="defaultPercentTakeProfit()"
			(changePriceStopLoss)="togglePriceSlTp('stop-loss', $event)"
			(changeActiveStopLoss)="toggleActiveSlTp('stop-loss', $event)"
			(changePriceTakeProfit)="togglePriceSlTp('take-profit', $event)"
			(changeActiveTakeProfit)="toggleActiveSlTp('take-profit', $event)"
		/>

		<div class="trailing-stop">
			<div class="trailing-stop-switcher">
				<input
					type="checkbox"
					tuiSwitch
					size="s"
					[showIcons]="false"
					[ngModel]="isTrailingStopActive()"
					(ngModelChange)="toggleTrailingStop($event)"
				/>
				<label class="trailing-stop-label">{{ 'slTp.trailingStop' | translate }}</label>
			</div>

			<app-trailing-stop-controls
				[tickerPrice]="tickerPrice()"
				[disabled]="!isTrailingStopActive()"
				(changeTrail)="onChangeTrail($event)"
			/>
		</div>

		<app-button
			appearance="primary"
			size="l"
			[isDisabled]="isLoadingOrders() || isInvalidOrder()"
			[isLoading]="isLoadingCreateOCO()"
			(clicked)="isTrailingStopActive() ? createTrailingStopOrder() : createOcoOrder()"
		>
			{{ 'slTp.confirm' | translate }}
		</app-button>
	</div>
</div>
